<template>
  <div class="container">
    <div>
      <Item
        v-for="(item,idx) in list"
        :key="item.id"
        :id="item.id"
        :pid="item.pid"
        :index="idx"
        :num="item.number"
        :unitNumber="item.shopProduct.unitNumber"
        :thumb="item.shopProduct.image"
        :title="item.shopProduct.name"
        :desc="item.shopProduct.detail"
        :tag="item.tag"
        :tags="item.tags"
        :pdescription="item.pdescription"
        :originPrice="item.shopProduct.realPrice"
        :price="item.price"
        :isChecked="item.isChecked"
        @input="handleItemSelect"
        @handleDelete="handleDelete"
        @numsClick="numsClick"
      />
      <Footer :amount="amount" :value="isAllSelect" @input="handleAllSelect" @submitOrder="handleOrder"/>
    </div>
    <empty v-show="list.length == 0"/>
    <Recommend @getCartList="getList"/>
    <div class="submit-bar-placeholder" style="width:100%;height:50px"></div>
    <tabbar></tabbar>
  </div>
</template>

<script>
import { getShopCartList, updateShopCart, deleteShopCart } from '@/api/cart'
import Item from './modules/Item'
import Footer from './modules/Footer'
import Recommend from './modules/Recommend'
export default {
  name: 'Cart',
  components: {
    Item,
    Footer,
    Recommend
  },
  data() {
    return {
      loading: false,
      finished: false,
      list: [
        {
        shopProduct: {
          price: 0,
          unitNumber: 0
        }
      }
      ],
      orderProduct: [],
      amount: 0,
      isAllSelect: false,
      isSkeletonShow: true
    }
  },
  created() {
    this.getList()
  },
  watch: {
    list(newval) {
      let num = 0
      let flag = true;
      newval.forEach(item => {
        if (item.isChecked) {
          num += item.price * item.shopProduct.unitNumber * item.number
        }else{
          flag = false;
        }
      })
      // this.isAllSelect = newval.every(item => {
      //   return item.isChecked === true
      // })
      this.isAllSelect = flag;
      this.amount = num * 100
    }
  },
  methods: {
    //Triggered when the state is changed
    numsClick(row) {
      this.list[row.index].number = row.nums
      this.list[row.index].price = row.price
      let price = 0;
      this.list.forEach((item) => {
        if (item.isChecked) {
          price = price + (item.price * item.shopProduct.unitNumber * item.number)
        }
      })
      this.amount = price * 100
    },
    // get list
    getList() {
      let user = JSON.parse(localStorage.getItem("userInfo"));
      getShopCartList({ uid: user.id }).then(res => {
        if (res.success){
          const data = res.data
          data.forEach(item => {
            item.isChecked = false
          })
          this.list = data
        }
        this.isSkeletonShow = false
        this.loading = false;
        this.finished = true;
      })
    },
    // single select
    handleItemSelect(playload) {
      this.list[playload.idx].isChecked = playload.val
      let state = true
      let price = 0;
      this.orderProduct = [];
      this.list.forEach((item) => {
        if (item.isChecked) {
          price = price + (item.price * item.shopProduct.unitNumber * item.number)
          this.orderProduct.push(item)
        }else{
          state = false
        }
      })
      this.amount = price * 100
      this.isAllSelect = state
    },
    // all select
    handleAllSelect(value) {
      this.orderProduct = [];
      const data = this.list.map(item => {
        item.isChecked = value
        return item
      })
      this.list = data
      this.orderProduct = data
    },
    // submit order
    handleOrder() {
      // this.orderProduct = this.list
      if (this.orderProduct.length == 0) {
        this.$toast.fail('请选择商品！')
      } else {
        let cartIds = [];
        this.orderProduct.forEach((item) => {
          cartIds.push({id: item.id})
        })
        this.$router.push({
          path: '/order/cartBuy',
          query: { cartIds: JSON.stringify(cartIds) }
          //query: { rows: JSON.stringify(rows) }
        })
      }
    },
    // item delete
    handleDelete(id) {
      this.$toast.loading({
        message: '加载中...',
        overlay: true,
        duration: 1000,
        forbidClick: true
      })
      deleteShopCart(id).then(res => {
        if (res.success) {
          this.$toast.success('删除成功')
          this.getList()
        } else {
          this.$toast.fail(res.msg)
        }
      })
      this.$toast.clear()
    }

  }
}
</script>

<style lang="less" scoped>
  .container{
    width: 100vw;
    height: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-y: scroll;
    padding-top: 0px;
    padding-bottom: 50px;
    font-size: 14px;
    /*background-color: #FFFFFF;*/

  }

</style>



// WEBPACK FOOTER //
// src/views/cart/index.vue